<template>
    <v-container class="my-5">
        <!--     Diálogo Modal Persistente para Recortar Logotipo del Fraccionamiento      -->
        <v-dialog v-model="dialogImageLogo" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            mode="normal"
                            class="basic lg"
                            ref="clipperImageLogo"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="getCutingLogo()"
                    >{{$t('recortar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Registro     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_eliminar_directory')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            :loading="loadingDeleteLote"
                            @click="deleteLote()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo importar Casas     -->
        <v-dialog
                v-model="dialogImport"
                max-width="700"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('import_account_statements_file')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="clear(), dialogImport = false"
                    ><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <h3>{{$t('import_account_statements_file')}}</h3>
                    <br>
                    <v-file-input
                            v-model="file"
                            :rules="rules"
                            chips
                            show-size
                            accept=".xlsx"
                            :placeholder="$t('selecciona_archivo')"
                            :label="$t('archivo')"
                            :error-messages="errores.file"
                    ></v-file-input>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="dialogImport = false"
                    >
                        {{$t('cancelar')}}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            :loading="loading"
                            @click="importar()"
                    >
                            <v-icon dark left>mdi-database-import</v-icon>
                        {{$t('importar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{$t('account_statements')}}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="650">
                <v-form
                        @submit.prevent="update
                            ? updateDirectory(idUpdate)
                            : addLote()"
                >
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('relate_home')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false"
                            ><v-icon>mdi-close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text>
                           <v-layout row wrap class="justify-center">
                              <v-flex xs10>
                                  <v-autocomplete
                                    class="mr-3 mt-3 ml-3 mb-3"
                                    v-model="idHouse"
                                    prepend-icon="mdi-home-city"
                                    name="idHouse"
                                    :item-text="example"
                                    item-value="id"
                                    :label="$t('casas')"
                                    :placeholder="$t('search_by_house_number')"
                                    :filter="customFilterHouse"
                                    :items="houses"
                                    :error-messages="errores.idHouse"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                    outlined
                                    autocomplete="off"
                                >
                                  <template v-slot:item="data">
                                      <v-list-item-content>
                                        <v-list-item-title>
                                          <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                          <strong>{{data.item.lot_number === null ? 'n/a' : data.item.lot_number}}</strong>
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                  </template>
                                </v-autocomplete>
                              </v-flex>
                              <v-flex xs2>
                                <v-btn class="mt-3 mb-3" x-large :loading="loading" color="primary" @click="addLote">
                                  {{$t('agregar')}}
                                </v-btn>
                              </v-flex>
                           </v-layout>
                            <v-data-table
                                :headers="headerMainResidentsHouses"
                                :loading="loadingDataMainResidentsHouses"
                                :items="mainResidentsHouses"
                                :search="search"
                                :footer-props="{
                            itemsPerPageOptions: [
                                {text: this.$t('todos'), value: -1}
                            ],
                            itemsPerPageText: $t('filas_por_pagina')
                        }"
                                class="elevation-1"
                                :no-data-text="$t('no_records_yet')"
                            >
                              <template v-slot:item.action="{ item }">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="red"
                                        class="mr-2"
                                        @click="deleteDialog = true, idPrincipalResidentHouseDelete = item.id"
                                    >
                                      mdi-source-branch-remove
                                    </v-icon>
                                  </template>
                                  <span>{{$t('delete')}}</span>
                                </v-tooltip>
                              </template>
                              <template v-slot:no-results>
                                <v-alert type="warning">
                                  {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                                </v-alert>
                              </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout v-if="(getProfile.idHousingUnit === '8c19e21b-3e74-4405-aeb3-297f9f573ab1') || (getProfile.idHousingUnit === '3999d21c-555d-4be9-9179-c2cc34e2c825') || (getProfile.idHousingUnit === '4ffccfe3-0062-444d-aaab-df1e65cf9222') || (getProfile.idHousingUnit === 'bc7c051d-56eb-4dbf-b627-eca69ece6541')" row wrap class="justify-center">
            <v-layout row wrap class="justify-center">
              <v-flex xs12 v-if="accountStatements.length > 0">
                <br>
                <v-carousel
                    height="auto"
                    hide-delimiter-background
                    show-arrows-on-hover
                    hide-delimiters
                >
                  <v-carousel-item
                      v-for="(item, i) in accountStatements"
                      :key="i"
                  >
                    <v-card light>
                      <v-toolbar color="primary" class="white--text">
                        <v-toolbar-title>
                          {{item.address}}<br>
                          {{item.full_name}}
                        </v-toolbar-title>
                        <v-spacer/>
                        <!--                    <v-icon right dark>-->
                        <!--                      mdi-account-details-->
                        <!--                    </v-icon><br>-->
                        {{i + 1}} {{$t('de')}} {{accountStatements.length}}
                      </v-toolbar>
                      <v-card-text>
                        <v-data-table
                            :headers="headersAccountStatus"
                            :items="item.data"
                            :footer-props="{
                            itemsPerPageOptions: [
                                {text: 'todo', value: -1}
                            ],
                            itemsPerPageText: $t('filas_por_pagina')
                        }"
                            :no-data-text="$t('no_records_yet')"
                            class="elevation-1"
                        >
                        </v-data-table>
                      </v-card-text>
                      <v-card-actions>
                      </v-card-actions>
                    </v-card>
                  </v-carousel-item>
                </v-carousel>
              </v-flex>
              <v-flex xs12 v-else>
                <p class="display-2 text-center">{{$t('no_records_yet')}}</p>
              </v-flex>
            </v-layout>
        </v-layout>
        <v-layout v-else align-center justify-center fill-height>
          <v-flex class="text-center" xs2>
              <v-icon x-large right>
                mdi-account-cash
              </v-icon>
          </v-flex>
          <v-flex class="text-center"  xs10>
            <h2>Para habilitar <strong>Estados de cuenta</strong>, <br>favor de contactar a representante Intrare.</h2>
          </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'

Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'account_statements_main_resident',
  created () {
    this.getAccountStatements()
    this.getMainResidents()
    this.getHouses()
  },
  computed: {
    ...mapState(['language']),
    ...mapGetters(['getProfile'])
  },
  data: () => ({
    dialog: false,
    idHouse: '',
    name: '',
    number: '',
    nameAux: '',
    numberAux: '',
    header: [],
    loadingDataAccountStatements: false,
    loading: false,
    accountStatements: [],
    search: '',
    update: false,
    errores: [],
    errorsPhone: [],
    idUpdate: 0,
    idDirectoryDelete: 0,
    deleteDialog: false,
    dialogImageLogo: false,
    file: null,
    rules: [
      value => !!value || 'Archivo requerido.'
    ],
    headers: [],
    headerMainResidents: [],
    headerMainResidentsHouses: [],
    resultLogoURL: '',
    imageFrontURL: '',
    dialogImport: false,
    headersAccountStatus: [],
    mainResidents: [],
    mainResidentsHouses: [],
    houses: [],
    idMainResidentDelete: 0,
    idPrincipalResidentHouseDelete: 0,
    loadingDataMainResidentsHouses: false,
    loadingDeleteLote: false,
    loadingDataMainResidents: false
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        sortable: false,
        value: 'action'
      },
      {
        text: this.$t('nombre'),
        align: 'center',
        sortable: true,
        value: 'name'
      },
      {
        text: this.$t('telefono'),
        align: 'center',
        sortable: true,
        value: 'number'
      }
    ]
    this.headerMainResidents = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('residente_principal'),
        align: 'left',
        sortable: true,
        value: 'fullname'
      }
    ]
    this.headerMainResidentsHouses = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('residente_principal'),
        align: 'left',
        sortable: true,
        value: 'full_name'
      },
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'address'
      },
      {
        text: 'Lote',
        align: 'left',
        sortable: true,
        value: 'lot_number'
      }
    ]
    this.headersAccountStatus = [
      {
        text: 'Fecha',
        align: 'left',
        value: 'Fecha',
        filterable: false,
        sortable: false
      },
      {
        text: 'Serie',
        align: 'left',
        value: 'Serie',
        filterable: false,
        sortable: false
      },
      {
        text: 'Folio ',
        align: 'left',
        value: 'Folio',
        filterable: false,
        sortable: false
      },
      {
        text: 'Concepto',
        align: 'left',
        value: 'Concepto',
        filterable: false,
        sortable: false
      },
      {
        text: 'Cargos',
        align: 'left',
        value: 'Cargos',
        filterable: false,
        sortable: false
      },
      {
        text: 'Abonos',
        align: 'left',
        value: 'Abonos',
        filterable: false,
        sortable: false
      },
      {
        text: 'Saldo Documento',
        align: 'left',
        value: 'Saldo Documento',
        filterable: false,
        sortable: false
      },
      {
        text: 'Vence',
        align: 'left',
        value: 'Vence',
        filterable: false,
        sortable: false
      },
      {
        text: 'Tipo de Cambio',
        align: 'left',
        value: 'Tipo de Cambio',
        filterable: false,
        sortable: false
      },
      {
        text: 'Estado del Documento',
        align: 'left',
        value: 'Estado del Documento',
        filterable: false,
        sortable: false
      },
      {
        text: 'Referencia',
        align: 'left',
        value: 'Referencia',
        filterable: false,
        sortable: false
      }
    ]
  },
  methods: {
    getHouses () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.houses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    example: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number),
    customFilterHouse (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    getMainResidents () {
      this.loadingDataMainResidents = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/principalResidents/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.mainResidents = response.data.principal_residents
          this.loadingDataMainResidents = false
        })
        .catch(error => {
          this.loadingDataMainResidents = false
          console.log(error)
        })
    },
    getMainResidentsHouses (idResident) {
      this.loadingDataMainResidentsHouses = true
      this.mainResidentsHouses = []
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/account_status_json/principal_resident/' + idResident + '/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.mainResidentsHouses = response.data
          this.loadingDataMainResidentsHouses = false
        })
        .catch(error => {
          this.loadingDataMainResidentsHouses = false
          console.log(error)
        })
    },
    getAccountStatements () {
      this.loadingDataAccountStatements = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/account_status_json/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.accountStatements = response.data
          this.loadingDataAccountStatements = false
        })
        .catch(error => {
          this.loadingDataAccountStatements = false
          console.log(error)
        })
    },
    addLote () {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()

      bodyFormData.set('idHouse', this.idHouse)
      bodyFormData.set('idResident', this.idMainResidentDelete)
      bodyFormData.set('data', "\"''\"")
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/account_status/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_relate_home_add'))
          this.getMainResidentsHouses(this.idMainResidentDelete)
          this.idHouse = ''
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
              console.log(this.errores.phone2)
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    updateDirectory (id) {
      this.loading = true
      this.errores = []
      this.errorsPhone = []

      var bodyFormData = new FormData()
      var fileImageFront = null

      if (this.name !== this.nameAux) {
        bodyFormData.set('name', this.name)
      }
      if (this.number !== this.numberAux) {
        bodyFormData.set('number', this.number)
      }
      if (this.resultLogoURL !== this.resultAuxLogoURL) {
        const newID = this.$uuid.v4()
        if (this.resultLogoURL !== '' && this.resultLogoURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultLogoURL, 'logo_update' + newID + '.jpeg')
        }
        bodyFormData.append('icon', fileImageFront)
      }
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/directory_get_detail_and_update_it/' + id + '/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getDirectory()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_directory_modificado'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    deleteLote () {
      this.loadingDeleteLote = true
      const config = {
        method: 'delete',
        url: ' https://residencial-services.intrare.app/account_status/' + this.idPrincipalResidentHouseDelete + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Registro con ID = ', this.idPrincipalResidentHouseDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_relate_home_delete'))
        this.getMainResidentsHouses(this.idMainResidentDelete)
        setTimeout(this.clear, 3000)
        this.loadingDeleteLote = false
        this.deleteDialog = false
      })
        .catch(error => {
          this.loadingDeleteLote = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    getCutingLogo () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageLogo.clip() // call component's clip method
      this.resultLogoURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultLogoURL)
      this.dialogImageLogo = false
      this.dialog = true
    },
    cleanFields () {
      this.name = ''
      this.number = ''
      this.resultLogoURL = ''
      this.resultAuxLogoURL = ''
    },
    fillFields (item) {
      this.name = item.name
      this.number = item.number
      this.nameAux = item.name
      this.numberAux = item.number
      this.resultLogoURL = item.icon
      this.resultAuxLogoURL = item.icon
    },
    importar () {
      console.log(this.file)
      console.log('Rules = ', this.rules)
      this.errores = []
      this.loading = true
      var bodyFormData = new FormData()
      bodyFormData.append('file', this.file)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/excel/upload_account_statements/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('account_statements_imported_correctly'))
          this.dialogImport = false
          this.getAccountStatements()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            console.log(error.response.data)
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
          if (error.response.status === 500) {
            console.log('error 5000000')
            this.errores.file = 'Error en formato de archivo, favor de revisar el archivo que intenta importar.'
          }
        })
    },
    clear: function () {
      this.errores = []
      this.errorsPhone = []
      this.$store.commit('snackbar_change_color', 'success')
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  }
}
</script>

<style scoped>
.edge {
    border-radius: 8px;
    border-color: #81c81b #81c81b #81c81b #81c81b;
    border-width: 3px 3px 3px 3px;
    text-align: center;
    border-style: solid solid solid solid;
}
</style>
